import { json2csv_fn } from "@/utils/common";
import moment from 'moment';
import _ from 'lodash';
import locale from "@/helpers/locale";
export function exportCSV_fn(tableData, memberShipList, cinemaList, type) {
  if (tableData.length > 0) {
    console.log(type);
    let csvData = []
    const fields = type === 'brand' ? [
      {
        label: locale("report.memberShip.memberType"),
        value: "membershipId",
      },
      {
        label: locale("report.memberShip.windowOnline"),
        value: "windowOnline",
      },
      {
        label: locale("report.memberShip.cinema"),
        value: "cinemaId",
      },
      {
        label: locale("report.memberShip.createUpdate"),
        value: "createUpdate",
      },
      {
        label: locale("trans.other.price"),
        value: "price",
      },
      {
        label: locale("report.onlinebooking.visitor"),
        value: "visitor",
      },
      {
        label: locale("report.memberShipFeeSales.transactionAmount"),
        value: "transactionAmount",
      },
      {
        label: locale("report.memberShipFeeSales.transactionAmountTotal"),
        value: "transactionAmountTotal",
      },
    ]: [
      {
        label: locale("report.memberShip.memberType"),
        value: "membershipId",
      },
      {
        label: locale("report.memberShip.createUpdate"),
        value: "createUpdate",
      },
      {
        label: locale("trans.other.price"),
        value: "price",
      },
      {
        label: locale("report.onlinebooking.visitor"),
        value: "visitor",
      },
      {
        label: locale("report.memberShipFeeSales.transactionAmount"),
        value: "transactionAmount",
      },
      {
        label: locale("report.memberShipFeeSales.transactionAmountTotal"),
        value: "transactionAmountTotal",
      },
    ];
    let _tableData = _.cloneDeep(tableData)
    _tableData.forEach(row => {
      row.membershipId = row.type === 'memberTotal' || row.type === 'allTotal' ? row.membershipId : (memberShipList.find(item => item.id === row.membershipId) || {}).name
      row.cinemaId = !row.cinemaId ? 'ー' : (cinemaList.find(item => item.id === row.cinemaId) || {}).name
    })
    csvData = _tableData
    json2csv_fn(csvData, fields, moment().format("YYYYMMDDHHmm") + "_" + locale("report.memberShipFeeSales"));
  }
}